export default "__VITE_ASSET__C2rFeWxd__"